import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './main.css'

export const ScaleContext = React.createContext()

export default function Index() {
  const [globalScale, setGlobalScale] = useState([])

	return (
		<ScaleContext.Provider value={{globalScale, setGlobalScale}} >
			<App />
		</ScaleContext.Provider>
	)
}

ReactDOM.render(<Index />, document.getElementById('root'))
